/// <amd-module name="Repos/Common/Util/Editor" />
import { GitVersionDescriptor, TfvcVersionDescriptor } from "Repos/Common/Contracts/Git";
import { getTfvcVersionString, getVersionString } from "./Version";

export function getGitResourceUri(repositoryId: string, version: GitVersionDescriptor, path: string): string {
    return `inmemory://model/git/${repositoryId}/${encodeURIComponent(getVersionString(version))}${encodeURI(path)}`;
}

export function getTfvcResourceUri(version: TfvcVersionDescriptor, path: string): string {
    return `inmemory://model/tfvc/${encodeURIComponent(getTfvcVersionString(version))}${encodeURI(path)}`;
}
